import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FilterProvider } from "./context/FilterContext";
import { FilterSubProvider } from "./context/FilterContextSub";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <FilterProvider>
      <FilterSubProvider>
        <App />
      </FilterSubProvider>
    </FilterProvider>
  </QueryClientProvider>
);
